import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AdminPageLayout from '../../../layout/AdminPageLayout';
import BgImageContent from '../../../layout/BgImageContent';
import backgroundImage from '../../../assets/images/admin-bg.png';
import LoginForm from '../../../forms/login';
import { useSelector } from 'react-redux';
import { logout, selectIsAuthenticated, selectRole } from '../../../store/adminSlices/auth';
import Button from '../../../ui/Button';
import { useAppDispatch } from '../../../store';
import { APP_ROUTES } from '../../../app.config.vars/routes';
import LogoutIcon from '../../../assets/icons/logout.svg';
const LoginPage = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const role = useSelector(selectRole);
    const handleLogout = () => dispatch(logout());
    const navigateManageInstitutions = () => navigate(APP_ROUTES.institutions);
    const navigateManageFaq = () => navigate(APP_ROUTES.adminFaq);
    const navigateEditors = () => navigate(APP_ROUTES.editors);
    const navigateManageRallies = () => navigate(APP_ROUTES.adminManageRallies);
    return (_jsx(AdminPageLayout, { logoLink: role === 'super_admin'
            ? APP_ROUTES.institutions
            : role === 'admin'
                ? APP_ROUTES.editors
                : APP_ROUTES.adminManageRallies, children: _jsx("div", { className: `page-content-wrapper login-page${isAuthenticated ? ' logged-in' : ''}`, children: _jsx(BgImageContent, { backgroundColor: "#01978833", imageSrc: backgroundImage, imagePosition: 'bottom', title: t(isAuthenticated ? 'admin.logged_in' : 'admin.sign_in'), color: "#000", children: isAuthenticated ? (_jsxs(_Fragment, { children: [role === 'super_admin' && (_jsx(Button, { onClick: navigateManageInstitutions, label: t('button.manage_institutions') })), role === 'super_admin' && (_jsx(Button, { onClick: navigateManageFaq, label: t('button.manage_faq') })), role === 'admin' && (_jsx(Button, { onClick: navigateEditors, label: t('button.manage_editors') })), role === 'user' && (_jsx(Button, { onClick: navigateManageRallies, label: t('button.manage_rallies') })), _jsx(Button, { onClick: handleLogout, label: t('button.logout'), variant: 'outlined', icon: _jsx(LogoutIcon, {}), style: { width: 'max-content', margin: '0 auto' } })] })) : (_jsx(LoginForm, {})) }) }) }));
};
export default LoginPage;
